// ! This file contains functions to help with date formatting and manipulation
// ! It is a good practice to keep all date-related functions in one file

// ! Always use the same naming convention for all functions:
// ! Ex: parseDateToDDMMYY - always start with "parseDateTo" and then the format (DDMMYY)

// ! Add comments if the function is not self-explanatory

export function fromNewDateFormatToYYYYMMDDSlash(newDate) {
  let addZeroToMonth = false;

  let addZeroToDay = false;

  if (new Date(newDate).getDate() < 10) {
    addZeroToDay = true;
  }

  if (new Date(newDate).getMonth() + 1 < 10) {
    addZeroToMonth = true;
  }

  let date = new Date(newDate).getFullYear() + "/" + (addZeroToMonth ? "0" : "") + String(new Date(newDate).getMonth() + 1) + "/" + (addZeroToDay ? "0" : "") + new Date(newDate).getDate();

  return date;
}

export function parseNewDateToDDMMYYY(newDate) {
  return `${("0" + newDate.getDate()).slice(-2)}/${("0" + (newDate.getMonth() + 1)).slice(-2)}/${newDate.getFullYear()} ${("0" + newDate.getHours()).slice(-2)}:${("0" + newDate.getMinutes()).slice(
    -2
  )}:${("0" + newDate.getSeconds()).slice(-2)}`;
}

export function parseNewDateToDDMMYYYWithoutSeconds(newDate) {
  return `${("0" + newDate.getDate()).slice(-2)}/${("0" + (newDate.getMonth() + 1)).slice(-2)}/${newDate.getFullYear()} ${("0" + newDate.getHours()).slice(-2)}:${("0" + newDate.getMinutes()).slice(
    -2
  )}`;
}

export function parseNewDateToDDMMYYYnoTime(newDate) {
  return `${("0" + newDate.getDate()).slice(-2)}/${("0" + (newDate.getMonth() + 1)).slice(-2)}/${newDate.getFullYear()}`;
}
export function parseNewDateToYYMMDDDash(newDate) {
  return `${newDate.getFullYear()}-${("0" + (newDate.getMonth() + 1)).slice(-2)}-${("0" + newDate.getDate()).slice(-2)} ${("0" + newDate.getHours()).slice(-2)}:${("0" + newDate.getMinutes()).slice(
    -2
  )}:${("0" + newDate.getSeconds()).slice(-2)}`;
}
export function formatCardDate(date) {
  const now = new Date();
  const inputDate = new Date(date);

  // Calculate the difference in years between the current date and the input date
  const yearDiff = now.getFullYear() - inputDate.getFullYear();

  // Check if the date is within the last year
  const isYoungerThanOneYear = yearDiff < 1 || (yearDiff === 1 && now.getMonth() >= inputDate.getMonth() && now.getDate() >= inputDate.getDate());

  // Format the date
  if (isYoungerThanOneYear) {
    const day = String(inputDate.getDate()).padStart(2, "0");
    const month = String(inputDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const hours = String(inputDate.getHours()).padStart(2, "0");
    const minutes = String(inputDate.getMinutes()).padStart(2, "0");

    return `${day}/${month} ${hours}:${minutes}`;
  } else {
    const day = String(inputDate.getDate()).padStart(2, "0");
    const month = String(inputDate.getMonth() + 1).padStart(2, "0");
    const year = inputDate.getFullYear();

    return `${day}/${month}/${year}`;
  }
}

export function parseDateToDDMMYYTime(date) {
  if (date) {
    let d = new Date(date);
    let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
    let minutes = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
    let seconds = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
    let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
    let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    return day + "/" + month + "/" + d.getFullYear() + " " + hours + ":" + minutes + ":" + seconds;
  }
  return "";
}

export const formatDate = (date) => {
  if (date) {
    let d = new Date(date);
    let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
    let minutes = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
    let seconds = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
    let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
    let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    return day + "/" + month + "/" + d.getFullYear() + " " + hours + ":" + minutes + ":" + seconds;
  }
  return "";
};

export const getCurrentDateTimeString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = `0${now.getMonth() + 1}`.slice(-2); // Adding 1 because months are zero-based
  const day = `0${now.getDate()}`.slice(-2);
  const hours = `0${now.getHours()}`.slice(-2);
  const minutes = `0${now.getMinutes()}`.slice(-2);
  const seconds = `0${now.getSeconds()}`.slice(-2);
  return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
};

export function isDateObject(date) {
  if (date instanceof Date) {
    return true;
  } else {
    return false;
  }
}

//Function created to format seconds to years, months, days, hours, minutes & seconds --> Request of Jurgen
export function formatToTimeString(seconds) {
  if (seconds < 0) return "Invalid time";

  const units = [
    { label: "year", seconds: 31536000 },
    { label: "month", seconds: 2592000 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 },
  ];

  let remainingSeconds = seconds;
  const parts = [];

  units.forEach((unit) => {
    const count = Math.floor(remainingSeconds / unit.seconds);
    if (count > 0) {
      parts.push(`${count} ${unit.label}${count > 1 ? "s" : ""}`);
      remainingSeconds %= unit.seconds;
    }
  });

  return parts.length > 0 ? parts.join(" ") : "0 seconds";
}

// format time to HHh MMm SSs
export function formatToTimeStringHHMMSS(seconds) {
  if (seconds < 0) return "Invalid time";
  const roundedSeconds = Math.round(seconds);
  const hours = Math.floor(roundedSeconds / 3600);
  const minutes = Math.floor((roundedSeconds % 3600) / 60);
  const secs = roundedSeconds % 60;
  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  } else {
    return `${minutes}m ${secs}s`;
  }
}
